let appendedContent = '';   
var cntrlIsPressed = false;

if (sessionStorage['urls']) {
  var urls = JSON.parse(sessionStorage['urls'] || '[]')

  for (let i = 0; i < urls.length; i++ ) {
    const url = urls[i];

    if (url.path == window.location.pathname) {
      countPage = url.page
    }
  }
}

function detec() { 
  if (navigator.userAgent.match(/Android/i) 
      || navigator.userAgent.match(/webOS/i) 
      || navigator.userAgent.match(/iPhone/i)  
      || navigator.userAgent.match(/iPad/i)  
      || navigator.userAgent.match(/iPod/i) 
      || navigator.userAgent.match(/BlackBerry/i) 
      || navigator.userAgent.match(/Windows Phone/i)) { 
      return true; 
  } else {
    return false;
  }
} 

$(document).keydown(function(event) {
  switch(event.which) {
    case 17:
      cntrlIsPressed = true;
    case 91:
      cntrlIsPressed = true; 
    case 93:
      cntrlIsPressed = true;
    case 224:
      cntrlIsPressed = true;         
  }

  switch(event.button) {
    case 17:
        cntrlIsPressed = true;
      case 91:
        cntrlIsPressed = true; 
      case 93:
        cntrlIsPressed = true;
      case 224:
        cntrlIsPressed = true;         
  }

});

$(document).keyup(function(){
  cntrlIsPressed = false;
});

function getOS() {
  var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  if (os == 'Mac OS') {
    return true
  } else {
    return false;
  }

}

$(document).on('click', '.product-wrap', function(event) {

  var scrolled_Y = window.scrollY;
  var scrolled_X = window.scrollX;
  var scrolled = [scrolled_X, scrolled_Y];

  var leftButton = detec();
  var oS = getOS();

  if (leftButton) {
    saveScroll(countPage, scrolled, appendedContent);
  } 

  if (oS) {
    if (!event.metaKey) {
      switch (event.which) {
        case 1:
          saveScroll(countPage, scrolled, appendedContent);
          break;
        default:
          console.log("mac os df which");
      }
      switch(event.button) {
        case 0:
          saveScroll(countPage, scrolled, appendedContent);
          break;
        default:
          console.log(" mac osdf button");   
      }
    }
  } else {
    if (!cntrlIsPressed) {
      switch (event.which) {
        case 1:
          saveScroll(countPage, scrolled, appendedContent);
          break;
        default:
          console.log("df which");
      }
      switch(event.button) {
        case 0:
          saveScroll(countPage, scrolled, appendedContent);
          break;
        default:
          console.log("df button");   
      }
    }
  }
 
});

if (!enableInfiniteScroll()) {

  window.addEventListener('load', function(){
    $(window).bind('scroll', bindScroll)
  });
}